<!-- SEARCH INPUT -->
<div class="pointee-search-input" [class.ghost]="border === BorderStyle.Ghost">
  <input
    #searchInput
    type="text"
    data-testid="search-input"
    name="search-input"
    class="search-input"
    [class.bevel]="border === BorderStyle.Bevel"
    [(ngModel)]="searchValue"
    [disabled]="disabled"
    placeholder="{{ placeholder || 'Search...' }}"
    maxlength="100"
    autocomplete="off"
    autofocus
  />
  <span class="search-input-icon">
    <svg-icon key="search" />
  </span>
  @if (searchValue?.length > 0 || closeAlwaysVisible) {
    <button type="button" id="search-input-clear" class="btn clear-icon" (click)="clearSearch($event)"><svg-icon key="close" fontSize="12px" /></button>
  }
</div>
